import { useState } from 'react';

const COORDINATOR_WHATSAPP = '962779989666';
const SUPABASE_URL      = 'https://zgkggkmzrlipmvtmoytn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpna2dna216cmxpcG12dG1veXRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgwNDk3ODcsImV4cCI6MjA5MzYyNTc4N30.ASrXEfhOx6s-yrU_QWen9OK7EaIhrYRpxhJMZZwfHKw';

const SYMPTOMS = [
  { id:'pain',       ar:'الألم',            en:'Pain',               leftAr:'لا يوجد ألم',              rightAr:'أسوأ ألم ممكن',            leftEn:'No pain',          rightEn:'Worst pain' },
  { id:'tired',      ar:'التعب والإرهاق',   en:'Tiredness',          leftAr:'لا يوجد تعب أو إرهاق',    rightAr:'أسوأ تعب وإرهاق ممكن',     leftEn:'No tiredness',     rightEn:'Worst tiredness' },
  { id:'nausea',     ar:'الغثيان',           en:'Nausea',             leftAr:'لا يوجد غثيان أو قيء',    rightAr:'أسوأ غثيان ممكن',          leftEn:'No nausea',        rightEn:'Worst nausea' },
  { id:'depression', ar:'الاكتئاب',          en:'Depression',         leftAr:'غير مكتئب',                rightAr:'أسوأ حالة اكتئاب ممكنة',   leftEn:'Not depressed',    rightEn:'Worst depression' },
  { id:'anxiety',    ar:'القلق',             en:'Anxiety',            leftAr:'غير قلق',                  rightAr:'أسوأ حالة قلق ممكنة',      leftEn:'Not anxious',      rightEn:'Worst anxiety' },
  { id:'drowsy',     ar:'النعاس والنوم',     en:'Drowsiness',         leftAr:'متيقظ تماماً',             rightAr:'أشد شعور بالنعاس',         leftEn:'Not drowsy',       rightEn:'Worst drowsiness' },
  { id:'appetite',   ar:'الشهية',            en:'Appetite',           leftAr:'أفضل شهية',                rightAr:'أسوأ شهية',                leftEn:'Best appetite',    rightEn:'Worst appetite' },
  { id:'wellbeing',  ar:'الشعور بالصحة',     en:'Wellbeing',          leftAr:'أفضل شعور بالصحة',        rightAr:'أسوأ شعور بالصحة',         leftEn:'Best wellbeing',   rightEn:'Worst wellbeing' },
  { id:'breath',     ar:'صعوبة التنفس',      en:'Shortness of Breath',leftAr:'لا توجد صعوبة تنفس',      rightAr:'أسوأ صعوبة تنفس',          leftEn:'No shortness',     rightEn:'Worst shortness' },
  { id:'sleep',      ar:'النوم',             en:'Sleep',              leftAr:'أفضل نوم',                 rightAr:'أسوأ نوم',                 leftEn:'Best sleep',       rightEn:'Worst sleep' },
];

const getColor = (v) => v === null ? '#ccc' : v <= 3 ? '#2E7D6B' : v <= 6 ? '#D4930A' : '#C0392B';
const getSeverity = (v, ar) => {
  if (v === null) return '';
  if (ar) return v <= 3 ? 'خفيف' : v <= 6 ? 'متوسط' : 'شديد';
  return v <= 3 ? 'Mild' : v <= 6 ? 'Moderate' : 'Severe';
};

function buildResultsText(scores, other, otherScore) {
  return [
    `Pain: ${scores['pain'] ?? '—'}`,
    `Tiredness: ${scores['tired'] ?? '—'}`,
    `Nausea or Vomiting: ${scores['nausea'] ?? '—'}`,
    `Depression: ${scores['depression'] ?? '—'}`,
    `Anxiety: ${scores['anxiety'] ?? '—'}`,
    `Drowsiness: ${scores['drowsy'] ?? '—'}`,
    `Appetite: ${scores['appetite'] ?? '—'}`,
    `Wellbeing: ${scores['wellbeing'] ?? '—'}`,
    `Shortness of Breath: ${scores['breath'] ?? '—'}`,
    `Sleep: ${scores['sleep'] ?? '—'}`,
    other?.trim() ? `Other symptoms (${other}): ${otherScore ?? '—'}` : `Other symptoms: —`,
  ].join('\n');
}

async function sendEmail(mrn, date, scores, other, otherScore) {
  const res = await fetch(
    `${SUPABASE_URL}/functions/v1/send-esas-email`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({ mrn, date, scores, other, otherScore }),
    }
  );
  const text = await res.text();
  console.log('Edge function response:', res.status, text);
  try {
    const data = JSON.parse(text);
    if (!data.ok) throw new Error(data.error || text);
    return true;
  } catch(e) {
    throw new Error(`HTTP ${res.status}: ${text}`);
  }
}

export default function ESASForm() {
  const [lang, setLang]         = useState('ar');
  const [mrn, setMrn]           = useState('');
  const [date, setDate]         = useState(new Date().toISOString().split('T')[0]);
  const [scores, setScores]     = useState({});
  const [other, setOther]       = useState('');
  const [otherScore, setOtherScore] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted]   = useState(false);
  const [error, setError]       = useState('');
  const isAr = lang === 'ar';

  const handleSubmit = async () => {
    if (!mrn.trim()) { setError(isAr ? 'الرجاء إدخال رقم الملف الطبي' : 'Please enter MRN'); return; }
    const unanswered = SYMPTOMS.filter(s => scores[s.id] === undefined || scores[s.id] === null);
    if (unanswered.length > 0) {
      setError(isAr ? `الرجاء الإجابة على جميع الأسئلة (${unanswered.length} متبقٍ)` : `Please answer all questions (${unanswered.length} remaining)`);
      return;
    }
    setError(''); setSubmitting(true);
    try {
      await sendEmail(mrn, date, scores, other, otherScore);
      setSubmitted(true);
    } catch(e) {
      console.error('Submit error:', e);
      setError(`Error: ${e?.message || 'Unknown error'}`);
    }
    setSubmitting(false);
  };

  const handleWhatsApp = () => {
    const results = buildResultsText(scores, other, otherScore);
    const msg = `السلام عليكم، لقد أكملت استبيان الأعراض ESAS-A. رقم الملف: ${mrn} التاريخ: ${date} الرجاء مراجعة النتائج المرفقة.\n\nESAS filled electronically:\n==================\n${results}`;
    window.open(`https://wa.me/${COORDINATOR_WHATSAPP}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  // ── THANK YOU SCREEN ──────────────────────────────────────────
  if (submitted) return (
    <div style={{ minHeight:'100vh', background:'#F5EFE6', display:'flex', alignItems:'center', justifyContent:'center', padding:20, fontFamily:'Arial,sans-serif' }}>
      <div style={{ background:'#fff', borderRadius:16, padding:32, maxWidth:460, width:'100%', boxShadow:'0 4px 24px rgba(0,0,0,0.10)' }}>
        <div style={{ textAlign:'center', marginBottom:24 }}>
          <div style={{ fontSize:52, marginBottom:12 }}>✅</div>
          <div style={{ fontSize:22, fontWeight:700, color:'#2E7D6B', marginBottom:6 }}>شكراً لك</div>
          <div style={{ fontSize:18, fontWeight:600, color:'#3D4F5C', marginBottom:10 }}>Thank You</div>
          <div style={{ fontSize:13, color:'#666', lineHeight:1.8 }}>
            تم إرسال إجاباتك بنجاح إلى الفريق الطبي.<br/>
            Your responses have been sent to the medical team.
          </div>
        </div>

        {/* WhatsApp button */}
        <div style={{ background:'#F5EFE6', borderRadius:12, padding:'16px 18px', marginBottom:20 }}>
          <div style={{ fontSize:13, fontWeight:700, color:'#3D4F5C', marginBottom:8 }}>
            {isAr ? 'أرسل النتائج إلى منسقة العيادة:' : 'Send results to clinic coordinator:'}
          </div>
          <div style={{ fontSize:12, color:'#888', marginBottom:12, lineHeight:1.6 }}>
            {isAr
              ? 'اضغط على الزر أدناه لإرسال النتائج عبر واتساب إلى منسقة العيادة'
              : 'Tap the button below to send results via WhatsApp to the clinic coordinator'}
          </div>
          <button onClick={handleWhatsApp}
            style={{ width:'100%', padding:'14px', background:'#25D366', color:'#fff', border:'none', borderRadius:10, fontSize:15, fontWeight:700, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', gap:10 }}>
            <span style={{ fontSize:20 }}>💬</span>
            <span>{isAr ? 'إرسال عبر واتساب' : 'Send via WhatsApp'}</span>
          </button>
        </div>

        <div style={{ padding:'12px 14px', background:'#F5EFE6', borderRadius:8, textAlign:'center', fontSize:11, color:'#888' }}>
          King Hussein Cancer Center · قسم الرعاية التلطيفية
        </div>
      </div>
    </div>
  );

  // ── FORM ──────────────────────────────────────────────────────
  return (
    <div style={{ minHeight:'100vh', background:'#F5EFE6', fontFamily:'Arial,sans-serif' }} dir={isAr ? 'rtl' : 'ltr'}>

      {/* Header */}
      <div style={{ background:'#3D4F5C', borderBottom:'4px solid #C8956C' }}>
        <div style={{ maxWidth:680, margin:'0 auto', padding:'14px 18px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ color:'#C8956C', fontSize:13, fontWeight:700, letterSpacing:'0.5px' }}>KING HUSSEIN CANCER CENTER</div>
            <div style={{ color:'rgba(245,239,230,0.75)', fontSize:12, marginTop:2 }}>
              {isAr ? 'قسم الرعاية التلطيفية' : 'Palliative Medicine Department'}
            </div>
          </div>
          <div style={{ display:'flex', background:'rgba(255,255,255,0.1)', borderRadius:8, overflow:'hidden' }}>
            <button onClick={() => setLang('ar')} style={{ padding:'7px 14px', border:'none', background:isAr?'#C8956C':'transparent', color:isAr?'#fff':'rgba(245,239,230,0.65)', fontSize:13, fontWeight:600, cursor:'pointer' }}>عربي</button>
            <button onClick={() => setLang('en')} style={{ padding:'7px 14px', border:'none', background:!isAr?'#C8956C':'transparent', color:!isAr?'#fff':'rgba(245,239,230,0.65)', fontSize:13, fontWeight:600, cursor:'pointer' }}>English</button>
          </div>
        </div>
      </div>

      <div style={{ maxWidth:680, margin:'0 auto', padding:'18px 16px 70px' }}>

        {/* Title */}
        <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:19, fontWeight:700, color:'#3D4F5C', marginBottom:3 }}>
            {isAr ? 'الميزان الرقمي لتقدير الأعراض' : 'Edmonton Symptom Assessment System'}
          </div>
          <div style={{ fontSize:13, color:'#C8956C', fontWeight:600, marginBottom:10 }}>ESAS-A</div>
          <div style={{ fontSize:13, color:'#555', lineHeight:1.7, padding:'10px 14px', background:'#F5EFE6', borderRadius:8 }}>
            {isAr
              ? 'نرجو الضغط على الرقم الذي يصف شدة الأعراض لديك الآن. صفر = لا يوجد، ١٠ = أشد ما يمكن'
              : 'Please select the number that best describes how you feel right now. 0 = None, 10 = Worst possible'}
          </div>
          <div style={{ display:'flex', gap:14, marginTop:12, flexWrap:'wrap' }}>
            {[['#2E7D6B', isAr?'خفيف (٠-٣)':'Mild (0–3)'], ['#D4930A', isAr?'متوسط (٤-٦)':'Moderate (4–6)'], ['#C0392B', isAr?'شديد (٧-١٠)':'Severe (7–10)']].map(([c,l]) => (
              <div key={c} style={{ display:'flex', alignItems:'center', gap:6, fontSize:12 }}>
                <div style={{ width:11, height:11, borderRadius:'50%', background:c }}/>
                <span style={{ color:'#555' }}>{l}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Patient info */}
        <div style={{ background:'#fff', borderRadius:14, padding:'16px 20px', marginBottom:14, boxShadow:'0 2px 12px rgba(60,50,40,0.09)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:14, fontWeight:700, color:'#3D4F5C', marginBottom:12 }}>
            {isAr ? 'معلومات المريض' : 'Patient Information'}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div>
              <label style={ls.label}>{isAr ? 'رقم الملف الطبي (MRN)' : 'Medical Record No. (MRN)'}</label>
              <input style={ls.input} placeholder={isAr?'أدخل رقم الملف':'Enter MRN'} value={mrn} onChange={e => setMrn(e.target.value)} />
            </div>
            <div>
              <label style={ls.label}>{isAr ? 'التاريخ' : 'Date'}</label>
              <input style={ls.input} type="date" value={date} onChange={e => setDate(e.target.value)} />
            </div>
          </div>
        </div>

        {/* Symptom cards */}
        {SYMPTOMS.map(symptom => {
          const val = scores[symptom.id] ?? null;
          const c   = getColor(val);
          return (
            <div key={symptom.id} style={{
              background: val !== null ? (val<=3?'rgba(46,125,107,0.05)':val<=6?'rgba(212,147,10,0.05)':'rgba(192,57,43,0.05)') : '#fff',
              borderRadius:13, padding:'16px 18px', marginBottom:10,
              boxShadow:'0 2px 10px rgba(60,50,40,0.08)',
              border:`1.5px solid ${val !== null ? c+'44' : 'rgba(200,149,108,0.18)'}`,
              transition:'all 0.15s'
            }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
                <div>
                  <div style={{ fontSize:16, fontWeight:700, color:'#3D4F5C' }}>{isAr ? symptom.ar : symptom.en}</div>
                  {isAr && <div style={{ fontSize:11, color:'#aaa', marginTop:1 }}>{symptom.en}</div>}
                </div>
                {val !== null && (
                  <div style={{ textAlign:'center' }}>
                    <div style={{ fontSize:26, fontWeight:700, color:c, lineHeight:1 }}>{val}</div>
                    <div style={{ fontSize:10, color:c, fontWeight:600, marginTop:2 }}>{getSeverity(val, isAr)}</div>
                  </div>
                )}
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}>
                <span style={{ fontSize:10, color:'#2E7D6B', fontWeight:600, maxWidth:'42%', lineHeight:1.3 }}>{isAr ? symptom.leftAr : symptom.leftEn}</span>
                <span style={{ fontSize:10, color:'#C0392B', fontWeight:600, maxWidth:'42%', lineHeight:1.3, textAlign:isAr?'left':'right' }}>{isAr ? symptom.rightAr : symptom.rightEn}</span>
              </div>
              <div style={{ display:'flex', gap:3 }}>
                {[0,1,2,3,4,5,6,7,8,9,10].map(n => {
                  const sel = val === n;
                  const nc  = n<=3?'#2E7D6B':n<=6?'#D4930A':'#C0392B';
                  return (
                    <button key={n} onClick={() => setScores(prev => ({ ...prev, [symptom.id]: n }))}
                      style={{ flex:1, padding:'11px 0', border:`2px solid ${sel?nc:'#E0DDD8'}`, borderRadius:8, background:sel?nc:'#fff', color:sel?'#fff':nc, fontSize:14, fontWeight:700, cursor:'pointer', transition:'all 0.1s' }}>
                      {n}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}

        {/* Other symptom */}
        <div style={{ background:'#fff', borderRadius:13, padding:'16px 18px', marginBottom:14, boxShadow:'0 2px 10px rgba(60,50,40,0.08)', border:'1px solid rgba(200,149,108,0.18)' }}>
          <div style={{ fontSize:14, fontWeight:700, color:'#3D4F5C', marginBottom:4 }}>{isAr ? 'عرض آخر (اختياري)' : 'Other Symptom (optional)'}</div>
          <div style={{ fontSize:12, color:'#888', marginBottom:10 }}>{isAr ? 'إذا كان لديك عرض آخر اذكره هنا' : 'If you have another symptom, describe it here'}</div>
          <input style={{ ...ls.input, marginBottom:10 }} placeholder={isAr?'اذكر العرض...':'Describe symptom...'} value={other} onChange={e => setOther(e.target.value)} />
          {other.trim() && (
            <div style={{ display:'flex', gap:3 }}>
              {[0,1,2,3,4,5,6,7,8,9,10].map(n => {
                const sel = otherScore === n;
                const nc  = n<=3?'#2E7D6B':n<=6?'#D4930A':'#C0392B';
                return (
                  <button key={n} onClick={() => setOtherScore(n)}
                    style={{ flex:1, padding:'11px 0', border:`2px solid ${sel?nc:'#E0DDD8'}`, borderRadius:8, background:sel?nc:'#fff', color:sel?'#fff':nc, fontSize:14, fontWeight:700, cursor:'pointer' }}>
                    {n}
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {error && (
          <div style={{ background:'#FFF0F0', border:'1px solid #F4A8A8', color:'#8A2D2D', padding:'12px 16px', borderRadius:10, fontSize:13, marginBottom:14, textAlign:'center' }}>
            {error}
          </div>
        )}

        <button onClick={handleSubmit} disabled={submitting}
          style={{ width:'100%', padding:'16px', background:submitting?'#aaa':'linear-gradient(135deg, #2E7D6B, #4A9E89)', color:'#fff', border:'none', borderRadius:12, fontSize:16, fontWeight:700, cursor:submitting?'default':'pointer', letterSpacing:'0.3px' }}>
          {submitting
            ? (isAr ? 'جاري الإرسال...' : 'Submitting...')
            : (isAr ? 'إرسال الإجابات ✓' : 'Submit Responses ✓')}
        </button>

        <div style={{ textAlign:'center', marginTop:12, fontSize:11, color:'#aaa', lineHeight:1.7 }}>
          {isAr
            ? 'إجاباتك سرية وستُرسل مباشرة إلى الفريق الطبي'
            : 'Your responses are confidential and will be sent directly to the medical team'}
        </div>
      </div>
    </div>
  );
}

const ls = {
  label: { display:'block', fontSize:10, fontWeight:700, color:'#555', marginBottom:5, letterSpacing:'0.5px', textTransform:'uppercase' },
  input: { width:'100%', padding:'11px 13px', border:'1.5px solid rgba(200,149,108,0.25)', borderRadius:9, fontSize:14, color:'#2C2C2C', background:'#F5EFE6', outline:'none', boxSizing:'border-box', fontFamily:'Arial,sans-serif' },
};
